import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_mothers_day_picks: FaireThemeEntity = {
  token: "discovery_theme_mothers-day-picks",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Mother's Day Picks",
  description:
    "Thoughtful, giftable finds your patrons will actually use — calming ceramics, hand-poured candles, and small-batch keepsakes. Perfectly timed for Mother's Day shoppers looking for something heartfelt and handmade.",
  bgColor: "#F5D4E8",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
